import "./top.css";
import { useEffect } from "react";
import { OperationArea } from "../area";
import { OperationDonutChart } from "../graphics";
import { OperationTopProps } from "./top.props";
import { useLanguage, useWeb } from "../../../hooks";
import { vars } from "../../../assets";
import { webActions } from "../../../context";

const OperationTop: React.FC<OperationTopProps> = ({
  title,
  top = 5,
  data,
  currencySymbol,
}) => {
  const { t } = useLanguage();
  const { dispatch, arrayRandom20DarkColors } = useWeb();
  const { createArrayRandom20DarkColors } = webActions(dispatch);

  useEffect(() => createArrayRandom20DarkColors(), []);

  return (
    <>
      <OperationArea className="top-wrapper ml">
        <h2 className="top-title">
          {t.components.operations.donutchart.top} {top} <b>{title}</b>
        </h2>

        <section className="top-info">
          <OperationDonutChart
            className="top-donutchart-container"
            data={data}
            currencySymbol={currencySymbol}
            arrayRandomColors={arrayRandom20DarkColors}
          />

          <div className="top-detail-wrapper">
            {data.map((top: any, index: number) => {
              const color: string = top?.color?.length
                ? top.color
                : arrayRandom20DarkColors?.[index] ?? vars.colorBlackLight;

              return (
                <div
                  key={`top-${top}-${title}-${index}`}
                  className="top-detail-item-wrapper"
                >
                  {top.icon.startsWith("http") || top.icon.startsWith("/") ? (
                    <img
                      src={top.icon}
                      alt={top.name}
                      style={{
                        width: 20,
                        height: 20,
                        objectFit: "cover",
                        borderRadius: 4,
                      }}
                    />
                  ) : (
                    <span
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: 20,
                        fontSize: 16,
                        fontWeight: "bold",
                        color,
                      }}
                    >
                      {top.icon.length ? top.icon : top.name[0]}
                    </span>
                  )}
                  <span className="top-detail-item-name" style={{ color }}>
                    {top.name}
                  </span>
                  <div className="top-detail-item-value" style={{ color }}>
                    {top.value.toLocaleString("es-ES")}
                    {currencySymbol}
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      </OperationArea>
    </>
  );
};

export default OperationTop;
